export default __webpack_public_path__ + "static/media/notStrictEquality.ad2ae06c.png";